import { render, staticRenderFns } from "./ReferrersList.vue?vue&type=template&id=7c280ae0&"
import script from "./ReferrersList.vue?vue&type=script&lang=js&"
export * from "./ReferrersList.vue?vue&type=script&lang=js&"
import style0 from "./ReferrersList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports